const container = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
};

const chartContainer = {
  flexGrow: 1,
  minHeight: 0,
  display: 'flex',
  flexDirection: 'column',
};

const deviceLegend = {
  display: 'flex',
  flexWrap: 'wrap',
  flexDirection: 'row',
  columnGap: '20px',
};

const title = {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
};

const icon = {
  paddingTop: 3,
};

const footer = {
  marginTop: 'auto',
};

export const getStyles = () => ({
  container,
  chartContainer,
  deviceLegend,
  title,
  icon,
  footer,
});
